import 'datatables.net-dt/css/jquery.dataTables.css'
import 'datatables.net-buttons-dt/css/buttons.dataTables.css'
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import moment from 'moment';
import Help from '../../../generics/help';

const $ = require('jquery');
$.DataTable = require('datatables.net-dt');

require('datatables.net-buttons/js/dataTables.buttons.min' );

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const jzip = require( 'jszip');
require( 'datatables.net-buttons/js/buttons.html5.min' );
window.JSZip = jzip;

var session = sessionStorage.getItem('health_facilities_name');
var Config = require('../../../../config');
var report = require('../../../generics/report_head');


class CNTSReport extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.searching = this.searching.bind(this);		
		this.setTable = this.setTable.bind(this);
		this.excel_report = this.excel_report.bind(this);

		this.state = {
			health_facilities_id:"",
			start_date 	: "",
			end_date 	: "",

			columns_a1:[
				{title:'Donantes alogénicos'},
				{title:'Femenino'},
				{title:'Masculino'},
				{title:'Valorados'},
				{title:'Aceptados'},
				{title:'Exclusión Temporal'},
				{title:'Exclusión Definitiva'}
			],
			columns_a2:[
				{title: 'Mujeres 18-24'},
				{title: 'Hombres 18-24'},
				{title: 'Mujeres 25-44'},
				{title: 'Hombres 25-44'},
				{title: 'Mujeres 45-65'},
				{title: 'Hombres 45-65'},
				{title: 'Total Mujeres'},
				{title: 'Total Hombres'},
				{title: 'Total'},
			],
			columns_a3:[
				{title:""}
			],
			columns_a4:[
				{title:"Ingresos y Altas"}
			],
			columns_a5:[{title:'Egresos y bajas'}],
			columns_a6:[
				{title:""}
			],
			columns_c:[
				{title:'Eventos adversos a la donación'},
				{title:'No. Eventos'}
			],

			columns_d:[
				{title:''},
				{title:'Tipo'},
				
			],
			columns_e:[
				{title:'Marcadores'},
				{title:'Donantes'},
				/*{title:'Negativos'},
				{title:'Reactivos'}*/
			],

			columns_g1:[
				{title:'Nombre del puesto de sangrado'},
				{title:'Código'},
				{title:'No. unidades de sangre colectadas'}
			],
			columns_g2:[
				{title:'Fecha'},
				{title:'Lugar de colecta'},
				{title:'No. unidades de sangre colectadas'}
			],
			columns_h:[
				{title:'Determinación'},
				{title: 'Mujeres 18-24'},
				{title: 'Hombres 18-24'},
				{title: 'Mujeres 25-44'},
				{title: 'Hombres 25-44'},
				{title: 'Mujeres 45-65'},
				{title: 'Hombres 45-65'},
				{title: 'Total Mujeres'},
				{title: 'Total Hombres'},
				{title: 'Total'}
			],
			columns_i:[
				{title:'Sector'},
				{title:'Centro'},
				{title:'Código'},
			],
			columns_j:[
				{title:'O+', key:'O_pos'},
				{title:'O-', key:'O_neg'},
				{title:'A+', key:'A_pos'},
				{title:'A-', key:'A_neg'},
				{title:'B+', key:'B_pos'},
				{title:'B-', key:'B_neg'},
				{title:'AB+', key:'AB_pos'},
				{title:'AB-', key:'AB_neg'},
				{title:'TOTAL', key:'total'},
			],
			filename:"Reporte al CNTS",
			listado_a1:[],
			listado_a2:[],
			listado_a3:[],
			listado_a4:[],
			listado_a5:[],
			listado_a6:[],
			listado_c:[],
			listado_d:[],
			listado_g1:[],
			listado_g2:[],
			listado_e:[],
			listado_h:[],
			listado_i:[],
			listado_j:[],
			tbl_a:[],
			tbl_d:[],
			tbl_g:[],
			tbl_h:[],
			tbl_i:[],
			tbl_j:[],


			date_hour:"",
			medical:"",
		}
	}

	componentWillMount(){
		var medical = JSON.parse(sessionStorage.getItem('medical_staff'));

		this.setState({
			health_facilities_id: sessionStorage.getItem('health_facilities_id'),
			name:sessionStorage.getItem('health_facilities_name'),
			medical:(medical.lastname1 !== null ? medical.lastname1 : "")+' '+
					(medical.lastname2 !== null ? medical.lastname2 : "")+' '+medical.names
		});

		if(!this.props.hiddeToReport){
			this.props.reload();
		}
	}

	componentDidMount(){
		this.props.waiting.handleShow('Cargando...');
		setTimeout(()=>{
			this.props.waiting.handleClose();
		}, 300)

		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			var aux = response.split('|');
			var date = aux[0].split("/");
			var hours = this.getHourFormat(aux[1]);

			this.setState({
				start_date:date[2]+'-'+date[1]+'-'+date[0],
				end_date:date[2]+'-'+date[1]+'-'+date[0],
				date_hour:aux[0]+' '+hours,
			});
		})

		
		this.setTable(this.el_a1, 'a1', this.state.columns_a1, this.state.listado_a1, '25em','', []);
		this.setTable(this.el_a2, 'a', this.state.columns_a2, this.state.listado_a2, '5em','', []);
		this.setTable(this.el_a3, 'a', this.state.columns_a3, this.state.listado_a3, '5em','', []);
		this.setTable(this.el_a4, 'a', this.state.columns_a4, this.state.listado_a4, '28em','', []);
		this.setTable(this.el_a5, 'a', this.state.columns_a5, this.state.listado_a5, '25em','', []);
		this.setTable(this.el_a6, 'a', this.state.columns_a6, this.state.listado_a6, '5em','', []);
		this.setTable(this.el_c, 'c', this.state.columns_c, this.state.listado_c, '20em','', []);
		this.setTable(this.el_d, 'd', this.state.columns_d, this.state.listado_d, '32em','headers', []);
		this.setTable(this.el_e, 'e', this.state.columns_e, this.state.listado_e, '30em','', []);
		this.setTable(this.el_g1, 'g1', this.state.columns_g1, this.state.listado_g1, '25em','', []);
		this.setTable(this.el_g2, 'g', this.state.columns_g2, this.state.listado_g2, '25em','', []);
		this.setTable(this.el_h, 'h',	this.state.columns_h, this.state.listado_h, '32em','', []);
		this.setTable(this.el_i, 'i',this.state.columns_i, this.state.listado_i, '32em','', []);
		this.setTable(this.el_j, 'j',this.state.columns_j, this.state.listado_j,'5em','', []);
	}

	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}

	generateExcel(section){
		var obj = {
			start_date: this.state.start_date,
			end_date: this.state.end_date,
			health_facilities_id:this.state.health_facilities_id,
			hf_id_log:sessionStorage.getItem('health_facilities_id'),
			report_key: section
		};

		this.props.waiting.handleShow('Generando...');
		fetch(Config.default.apiGateway.URL+'reports/generate_excel', {
			method : 'post',
			body:JSON.stringify(obj),
			responseType: 'blob',
			headers : new Headers({
				'Authorization': 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		})
		.then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.blob();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response =>{
			if(response !== undefined){
				this.props.fileDownload(this.state.filename, ".xlsx", 'application/vnd.ms-excel', response);
			}
		})
	}

	setTable(element, section, columns, listado, scll_y, head, defs){
		var fechas = (this.state.start_date !== "" ? moment(this.state.start_date).format("DD/MM/YYYY"): '')+ 
					" - "+(this.state.end_date !== "" ? moment(this.state.end_date).format("DD/MM/YYYY") : '') 
		var btns = [{
               extend: 'excelHtml5',
               title: this.state.filename
       },
    	{
        	extend: 'pdf',
        	title: this.state.filename,
        	customize: (doc)=> { 
        		var title = '';
        		var tbl = [];
               	var w = [];
               	doc.content.unshift({
                   	image: this.props.header_document,
                   	alignment:'center',
                   	width:this.props.w_head
               	});

               	doc.content.splice(2, 0, {text: fechas, margin:[10,0,0,10] });


               	/*var tbl = [];
              	var w = [];

        		doc.pageMargins = [ 40, 80, 40, 40 ];
        		doc.header = (currentPage, pageCount, pageSize)=>{
				    return [
				    	{table:{
				    		body:[
				    			[{
				    				image: report.default.img3,
									alignment:'center',
									width:35,
									height: 27,
									rowSpan:3,
									margin:[0,0,-3,0]
				    			}, {}],
				    			[{},{text:'INSTITUTO MEXICANO DEL SEGURO SOCIAL', color:'#1f6157', font:'Optim', fontSize:10, bold:1}],
				    			[{},{text:'INSTITUTO SEGURIDAD Y SOLIDARIDAD SOCIAL',color:'#1f6157', font:'Optim', fontSize:4.9, margin:[0,-3,0,0]}]
				    		]
				    	}, margin:[175,5,0,0], layout:'noBorders'},
				    	{text:this.state.name,alignment:'center', fontSize:6},
				    	{text:this.state.date_hour,alignment:'center', fontSize:7},
						{text:this.state.filename.toUpperCase(),alignment:'center', bold:1, fontSize:8},
				    ]
				}
				doc.content.splice(0,1)*/

        		if(section === 'a1'){
        			doc.content[3] = this.state.tbl_a;
        		}

        		if(section === 'g1'){
        			doc.content[3] = this.state.tbl_g;
        		}

        		if(section === 'c'){
        			title = 'Sección C .- Eventos o reacciones adversas a la donación';
	        		
	        		var w_c = 100 / this.state.columns_c.length;
            		this.state.columns_c.map((c, i)=>{
            			w.push(w_c+'%')
            		});


            		doc.content[3].table.body.map((body, i)=>{
            			if(i> 0){
            				body.map((b, j)=>{
	            				if(j>0){
		            				b.alignment = 'center';
		            			}
	            			})
            			}
            		});
        		}

        		if(section === 'd'){
        			title = 'Seccion D .- Resultados de las pruebas de detección de agentes transmisibles por transfusión';
        	
            		var col_d = [];
            		tbl = this.state.tbl_d;
            		w = ['40%'];
            		var aux = 60/(this.state.columns_d.length - 2)
            		this.state.columns_d.map((c, i)=>{
            			if(i>0){
							console.log(i, c.title)
            				col_d.push({text:c.title,style:'tableHeader', alignment:i>1?'right':'center'});
            				//col_d.push({text:c.title,style:'tableHeader', alignment:'right'});
            				if(i > 1){
	            				w.push(aux+'%');
	            			}
            			}
	            			
            		})
            		tbl.unshift(col_d);
            		//w = ["40%","10%","10%","10%","10%","10%","10%"]
        		}

        		if(section === 'e'){
        			title = 'Seccion E .- Resultados de otras pruebas de detección de agentes transmisibles por transfusión en donantes alogénicos.';

            		var w_e = 100 / this.state.columns_e.length;
            		this.state.columns_e.map((c, i)=>{
            			w.push(w_e+'%')
            		});

            		doc.content[3].table.body.map((body, i)=>{
            			if(i> 0){
            				body.map((b, j)=>{
	            				if(j>0){
		            				b.alignment = 'center';
		            			}
	            			})
            			}
            		});
        		}



        		if(section == 'h'){
        			title = 'Sección H .- Causas de diferimiento o rechazo de donantes por género y rango de edad';
        			var col_h = [];
            		tbl = this.state.tbl_h;
            		this.state.columns_h.map((c, i)=>{
            			col_h.push({text:c.title,style:'tableHeader', alignment:i>1?'right':'center'});
            		})
            		tbl.unshift(col_h);

            		w = ["15%","10%","10%","10%","10%","10%","10%","10%","10%","5%"];

        		}

        		if(section === 'i'){
        			title = 'Sección I .-  Desglose de intercambio de unidades de sangre y componentes sanguíneos';
        			var col_i = [];
            		tbl = this.state.tbl_i;
            		this.state.columns_i.map((c, i)=>{
            			if(i>0){
            				col_i.push({text:c.title,style:'tableHeader', alignment:i>1?'right':'center'});
            			}
            		})
            		tbl.unshift(col_i);

        		}

        		if(section === 'j'){
        			title = 'Sección J .- Grupo sanguíneo de los donadores';
        			var col_j = [];
            		tbl = this.state.tbl_j;
            		this.state.columns_j.map((c, i)=>{
            			col_j.push({text:c.title,style:'tableHeader', alignment:'center'});
            		})
            		tbl.unshift(col_j);

            		w = ["10%","10%","10%","10%","10%","10%","10%","10%","10%","15%"];

        		}
            	
            	if(section !== 'a1' && section !== 'g1'){
            		doc.content.splice(3, 0, {text:title, margin:[0,20,0,0], fontSize:12});
            		var num = section === 'c' ? 2 : 1;
            		if(section === 'c'){
            			doc.content.splice(1, 0, {text:'Eventos adversos a la donación', margin:[0,0,0,10], fontSize:10});
            			doc.content[5].table.widths = w;
            		}

	            	if(section !== 'e' && section !== 'c'){
	            		doc.content[4].table.body = tbl;

	            	}

	            	if(section !== 'i' && section !== 'c'){
	            		doc.content[4].table.widths = w;
	            	}
            	}
	            	
        		
				doc.styles.tableHeader.fontSize = 6.5;
        		doc.defaultStyle.fontSize = 6.5; 
        		//doc.styles.tableHeader.fillColor = this.props.base;

        		doc.footer = {text: this.state.date_hour+'\t-\t'+this.state.medical, alignment: 'right',margin: [ 0, 0, 50, 0 ]};
        		/*doc.footer = (currentPage, pageCount)=>{ 
        			return {
        				columns:[
        					{text:'Fecha de Impresión: '+this.state.date_hour, margin:[50,0,0,0]},
        					{ text: 'Página '+currentPage.toString() + ' de ' + pageCount, alignment: 'right', margin:[0,0,50,0] }
        				]
        			}; 
        		}*/
        		console.log(doc)
        	} 
    	}];



		var group = {
			dom: 'Bfrtip',
			buttons: section !== 'a' && section !== 'g' ? btns : [],
			data: listado,
			columns:columns,
			columnDefs: defs,
			oLanguage:{
				"sProcessing":"Procesando...",
				"sZeroRecords":"No se encontraron resultados",
				"sEmptyTable":"Ningún dato disponible en esta tabla",
				"sInfoPostFix":"",
				"sSearch":"Buscar:",
				"sUrl":"",
				"sInfoThousands":",",
				"sLoadingRecords":"Cargando...",
				"fnInfoCallback":null,
			},
			paging:false,
			responsive:false,
			searching: false,
			scrollY:scll_y,
			scrollX: true,
			autoWidth: true,
			info:false,
			ordering:false
		};

		this.$el = $(element);

		if(head !== ''){
	        group = {
				dom: 'Bfrtip',
				buttons: btns,
				data: listado,
				columns:columns,
				rowGroup: {dataSrc: [ 0 ]},
	        	columnDefs:  defs,
				oLanguage:{
					"sProcessing":"Procesando...",
					"sZeroRecords":"No se encontraron resultados",
					"sEmptyTable":"Ningún dato disponible en esta tabla",
					"sInfoPostFix":"",
					"sSearch":"Buscar:",
					"sUrl":"",
					"sInfoThousands":",",
					"sLoadingRecords":"Cargando...",
					"fnInfoCallback":null,
				},
				paging:false,
				responsive:false,
				searching: false,
				scrollY:scll_y,
				scrollX: true,
				autoWidth: true,
				info:false,
				ordering:false
			}
		}
		
		var table = this.$el.DataTable(group);

		if (table.rows().indexes().length === 0 ) {
			table.buttons('.dt-button').disable();
		}else {
			table.buttons('.dt-button').enable();
		}
	}

	handleChange(e){
		this.setState({
			[e.target.name]: e.target.value
		});

		var control = document.getElementById(e.target.name);
		
		if(control.required && control.className.includes('error')){
			control.classList.remove('error');
		}
	}

	timeConvert(n) {
		var num = n;
		var hours = (num / 60);
		var rhours = Math.floor(hours);
		var minutes = (hours - rhours) * 60;
		var rminutes = Math.round(minutes);
		return (rhours < 10 ? rhours : rhours) + ":" +
				(rminutes < 10 ? '0'+rminutes : rminutes) + "";
	}

	resetTable(element, btn, columns, listado, scll_y, head, def){
		setTimeout(()=>{
			this.props.waiting.handleShow('Cargando...');
			this.$el = $(element);
			this.$el.DataTable().destroy();
			this.$el.empty();
		}, 500);

		setTimeout(()=>{
			this.props.waiting.handleClose();
			this.setTable(element, btn, columns, listado,scll_y,head, def);
		}, 1000);
	}

	make_list(columns, array, item){
		columns.map((col, i)=>{
			if(i > 0){
				if(array[col.key] !== undefined){
					item.push(array[col.key])
				}else{
					item.push('');
				}
					

				/*var index = array.findIndex(obj =>
					obj.component === col.key || obj.component === col.title
				)

				if(index !== -1){
					item.splice(i, 1, array[index].total)
				}else{
					item.push('');
				}*/
			}
				
		})

		return item;
	}

	make_pdf_a(tbl, body, columns, list, col){
		var w = [];
		columns.map((c, i)=>{
			body.push({text:c.title, style:'tableHeader', alignment:'center'})
			if(col === 'si'){
				if(i > 0){
					w.push((75 / (columns.length-1))+'%');
				}else{
					w.push('25%');
				}
				
			}else{
				w.push((100 / columns.length)+'%');
			}
			
		});

		tbl.table.body.push(body);
		
		list.map((a1)=>{
			body = [];
			a1.map((a, i)=>{

				if(i > 0){
					body.push({text:a, alignment:'center'});
				}else{
					if(col === 'si'){
						body.push({text:a, alignment:'left'});
					}else{
						body.push({text:a, alignment:'center'});
					}
					
				}
				
			})

			tbl.table.body.push(body);
		})

		tbl.table.widths = w;
	}

	make_pdf_g(tbl, body, columns, list, col){
		var w = [];
		columns.map((c, i)=>{
			body.push({text:c.title, style:'tableHeader', alignment:'center'})
			w.push((100 / columns.length)+'%');			
		});

		tbl.table.body.push(body);
		
		list.map((a1)=>{
			body = [];
			a1.map((a, i)=>{
				if(i > 1){
					body.push({text:a, alignment:'center'});
				}else{
					body.push({text:a, alignment:'left'});
				}
			})

			tbl.table.body.push(body);
		})

		tbl.table.widths = w;
	}

	make_list_ages(obj, array){
		if(array.length === 0){
			obj.push('', '');
		}else{
			if(array.length === 1){
				array.map((a)=>{
					if(a.sex === 'HOMBRE'){
						obj.push('', a.total);
					}else{
						obj.push(a.total, '');
					}
				});
			}else{
				if(array[0].sex === 'HOMBRE'){
					obj.push(array[1].total, array[0].total);
				}else{
					obj.push(array[0].total, array[1].total);
				}
			}
		}
		return obj;
	}

	excel_report(){
		if(this.isValidForm()){
			if(this.dateCompare()){
				var obj = {
					start_date:this.state.start_date,
					end_date:this.state.end_date,
					health_facilities_id:sessionStorage.getItem('health_facilities_id')
				};
				
				this.props.waiting.handleShow('Descargando...');
				fetch(Config.default.apiGateway.URL+'reports/excel_cnts',{
					method: 'POST',
					body:JSON.stringify(obj),
					responseType: 'blob',
					headers: new Headers({
						'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				}).then(res => {
					this.props.waiting.handleClose();
					if(res.ok){
						return res.blob();
					}else{
						res.text().then((msg)=>{
							swal('Error', msg, 'error');
						});
					}
				}).then(response => {
					if(response !== undefined){
						var blob = new Blob([response], {type: 'application/vnd.ms-excel'});
						var downloadUrl = URL.createObjectURL(blob);
						var a = document.createElement("a");
						a.href = downloadUrl;
						a.download = this.state.filename+'.xlsx';
						document.body.appendChild(a);
						a.click();
					}
				});
			}else{
				swal('Error', 'La Fecha Hasta debe ser mayor o igual a Fecha Desde', 'error');
			}
		}else{
			swal('Error', 'Campos Incompletos', 'error');
		}
	}

	searching(){
		var columns_a3 = [{title:'', width:'300px'}];
		var columns_a4 = [{title:"Ingresos y Altas", width:'300px'}];
		var columns_a5 = [{title:'Egresos y bajas', width:'300px'}];
		var columns_a6 = [{title:'', width:'300px'}];
		var columns_d = [{title:''},{title:'Tipo'}];
		var columns_e = [
			{title:'Marcadores'},
			{title:'Donantes', key:'total'},
			{title:'Resultados Negativos', key:'NEGATIVO'},
			{title:'Resultados Reactivos', key:'REACTIVO'},
			{title:'Resultados No Reactivos', key:'NO REACTIVO'},
			{title:'Zona Gris', key:'ZONA GRIS'},
		];
		var columns_h = this.state.columns_h;
		var columns_i = [
			{title:'Sector'},
			{title:'Centro'}
		];
		var columns_j = this.state.columns_j;

		if(this.isValidForm()){
			if(this.dateCompare()){
				var obj = {
					start_date:this.state.start_date,
					end_date:this.state.end_date,
					health_facilities_id:sessionStorage.getItem('health_facilities_id')
				};
				
				this.props.waiting.handleShow('Buscando...');
				fetch(Config.default.apiGateway.URL+'reports/new_special',{
					method: 'POST',
					body:JSON.stringify(obj),
					headers: new Headers({
						'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				}).then(res => {
					this.props.waiting.handleClose();
					if(res.ok){
						return res.json();
					}else{
						res.text().then((msg)=>{
							swal('Error', msg, 'error');
						});
					}
				}).then(response => {
					if(response !== undefined){
						var list_a1=[], list_a2=[],list_a3=[], list_a4=[],list_a5=[], list_a6=[];
						var list_c=[], list_g1=[], list_g2=[], list_d=[], list_e=[], list_h=[], list_i=[], list_j=[];
						var pdf_a=[], pdf_d=[], pdf_g=[], pdf_h=[], pdf_i=[], pdf_j=[];
						var defs_a1=[], defs_a2=[],defs_a3=[], defs_a4=[],defs_a5=[], defs_a6=[];
						var defs_c=[], defs_g1=[], defs_g2=[], defs_d=[], defs_e=[], defs_h=[], defs_i=[], defs_j=[];


						response.others.analitical_test.map((a, i)=>{
							columns_d.push({title:a.name, key:a.test_id});
						});

						response.others.blood_components.map((b, i)=>{
							columns_a3.push({title:b.name, key:b.key});
							columns_a4.push({title:b.name, key:b.key});
							columns_a5.push({title:b.name, key:b.key});
							columns_a6.push({title:b.name, key:b.key});
							columns_i.push({title:b.name, key:b.key});

						});

						var total_w=0, total_m=0, total=0, total_v=0, total_n_v=0, total_r_t=0, total_r_f=0;
						response.sectionA.dataObjects.map((obj, j)=>{
							obj.table.map((t, i)=>{
								switch(j){
									case 0:
										var obj_a1 = [
											t.donation_type,
											t.women,
											t.men,
											t.validated,
											t.accepted,
											t.reject_temporal,
											t.reject_forever
										]

										total_w+=t.women;
										total_m+=t.men;
										total_v+=t.validated;
										total_n_v+=t.accepted;
										total_r_t+=t.reject_temporal;
										total_r_f+=t.reject_forever;

										list_a1.push(obj_a1);
										break;
									case 1:
										var obj_a2 = [
											t.w_18_24,
											t.m_18_24,
											t.w_25_44,
											t.m_25_44,
											t.w_45_65,
											t.m_45_65,
											t.tot_M,
											t.tot_H,
											t.total
										];

										list_a2.push(obj_a2);
										break;
									case 2:
										var obj_a3 = [t.text];
										list_a3.push(this.make_list(columns_a3, t, obj_a3));
										break;
									case 3:
										var obj_a4 = [t.text];
										list_a4.push(this.make_list(columns_a3, t, obj_a4));
										break;
									case 4:
										var obj_a5 = [t.text];
										list_a5.push(this.make_list(columns_a5, t, obj_a5));
										break;
									case 5:
										var obj_a6 = [t.text];
										list_a6.push(this.make_list(columns_a6, t, obj_a6));
										break;
								}	
							})

							switch(j){
								case 0:
									var total_a1 = [];
									obj.tota_row.ItemArray.map((t)=>{
										total_a1.push(t);
									});
									list_a1.push(total_a1);
									break;
								
								case 3:
									var total_a4 = [];
									obj.tota_row.ItemArray.map((t)=>{
										total_a4.push(t);
									});
									list_a4.push(total_a4);
									break;
								case 4:
									var total_a5 = [];
									obj.tota_row.ItemArray.map((t)=>{
										total_a5.push(t);
									});
									list_a5.push(total_a5);
									break;
								

								
							}		
						})

						pdf_a.push({text:'Sección A .- Uso alogénico', margin:[0,0,0,5], fontSize:12});
						pdf_a.push({text:'Donantes alogénicos', margin:[0,0,0,10], fontSize:10});
						var tbl_a = {table:{body:[]}};
						var body = [];
						this.make_pdf_a(tbl_a, body, this.state.columns_a1, list_a1, 'si');
						
						pdf_a.push(tbl_a);

						tbl_a = {table:{body:[]}};
						body = [];
						pdf_a.push({text:'Donantes de acuedo a edad y sexo ', margin:[0,10,0,10], fontSize:10});
						this.make_pdf_a(tbl_a, body, this.state.columns_a2, list_a2, '');
						pdf_a.push(tbl_a);

						tbl_a = {table:{body:[]}};
						body = [];
						pdf_a.push({text:'Existencias al inicio del mes que informa', margin:[0,10,0,10], fontSize:10});
						this.make_pdf_a(tbl_a, body, columns_a3, list_a3, 'si');
						pdf_a.push(tbl_a);

						tbl_a = {table:{body:[]}};
						body = [];
						pdf_a.push({text:'Ingresos y altas', margin:[0,10,0,10], fontSize:10});
						this.make_pdf_a(tbl_a, body, columns_a4, list_a4, 'si');
						pdf_a.push(tbl_a);

						tbl_a = {table:{body:[]}};
						body = [];
						pdf_a.push({text:'Egresos y bajas', margin:[0,10,0,10], fontSize:10});
						this.make_pdf_a(tbl_a, body, columns_a5, list_a5, 'si');
						pdf_a.push(tbl_a);

						tbl_a = {table:{body:[]}};
						body = [];
						pdf_a.push({text:'Existencia al término del mes que informa', margin:[0,15,0,10], fontSize:10});
						this.make_pdf_a(tbl_a, body, columns_a6, list_a6, 'si');
						pdf_a.push(tbl_a);

						response.others.incidents_extraction.map((inc, i)=>{
							var obj_c = [inc.name];

							var index = response.sectionC.table.findIndex(obj =>
								obj.code === inc.name
							)
							if(index !== -1){
								obj_c.push(response.sectionC.table[index].total);	
							}else{
								obj_c.push('');
							}
							list_c.push(obj_c);
						})
						
						response.sectionD.dataObjects.map((data)=>{
							data.table.map((t)=>{
								var obj_d = [];
								data.headers.Info.map((info)=>{
									obj_d.push(info.name);
								});

								obj_d.push(t.code);

								columns_d.map((col, i)=>{
									if(i > 1){
										if(t['t_'+col.key] !== undefined){
											obj_d.push(t['t_'+col.key])
										}else{
											obj_d.push('');
										}
									}
										
								})

								list_d.push(obj_d);
							})
						});

						list_d.map((list, i)=>{
							var obj_pdf_d = []
							list.map((item, j)=>{
								if(j>0){
									obj_pdf_d.push({text:item, alignment:'right'});
								}else{
									var index = pdf_d.findIndex(obj => obj[0].text === item);

									if(index === -1){
										obj_pdf_d.push(
											{text:item, bold:1,colSpan:list.length-1, fillColor:'#dfdfdf'},
										);
										pdf_d.push(obj_pdf_d);
										obj_pdf_d = [];
									}

								}
							})

							pdf_d.push(obj_pdf_d)
						});

						response.sectionE.table.map((t)=>{
							var obj_e = [t.code];

							list_e.push(this.make_list(columns_e, t, obj_e));
						});

						response.sectionG.dataObjects.map((obj, i)=>{
							switch(i){
								case 0:
									obj.table.map((t)=>{
										list_g1.push([
											t.name,
											t.code,
											t.total
										]);
									});
									break;
								case 1:
									obj.table.map((t)=>{
										list_g2.push([
											moment(t.date).format('DD/MM/YYYY'),
											t.name,
											t.total
										]);
									});
									break;
							}
						});

						pdf_g.push({text:'Seccion G .- Colectas de sangre en puestos de sangrado fijos y colectas externas efectuadas por el banco de sangre', margin:[0,0,0,5], fontSize:12});
						pdf_g.push({text:'Colectas de sangre en puestos de sangrado fijo', margin:[0,0,0,10], fontSize:10});
						var tbl_g = {table:{body:[]}};
						var body = [];
						this.make_pdf_a(tbl_g, body, this.state.columns_g1, list_g1);
						
						pdf_g.push(tbl_g);

						tbl_g = {table:{body:[]}};
						body = [];
						pdf_g.push({text:'Colectas Externas', margin:[0,10,0,10], fontSize:10});
						this.make_pdf_a(tbl_g, body, this.state.columns_g2, list_g2, '');
						pdf_g.push(tbl_g);


						response.sectionH.table.map((t)=>{
							var obj_h = [
								t.reason,
								t.w_18_24,
								t.m_18_24,
								t.w_25_44,
								t.m_25_44,
								t.w_45_65,
								t.m_45_65,
								t.tot_M,
								t.tot_H,
								t.total
							];

							var obj_pdf_h = [
								{text:t.reason},
								{text:t.w_18_24, alignment:'right'},
								{text:t.m_18_24, alignment:'right'},
								{text:t.w_25_44, alignment:'right'},
								{text:t.m_25_44, alignment:'right'},
								{text:t.w_45_65, alignment:'right'},
								{text:t.m_45_65, alignment:'right'},
								{text:t.tot_M, alignment:'right'},
								{text:t.tot_H, alignment:'right'},
								{text:t.total, alignment:'right'},
							]

							list_h.push(obj_h);
							pdf_h.push(obj_pdf_h)
						});

						response.sectionI.dataObjects.map((data)=>{
							data.table.map((t)=>{
								var obj_i = [];

								data.headers.Info.map((info)=>{
									obj_i.push(info.name);
								});

								obj_i.push(t.text);

								columns_i.map((col, i)=>{
									if(i > 1){
										if(t[col.key] !== undefined){
											obj_i.push(t[col.key])
										}else{
											obj_i.push('');
										}
									}
										
								})

								list_i.push(obj_i);

							});
						});
						list_i.map((list, i)=>{
							var obj_pdf_i = []
							list.map((item, j)=>{
								if(j>0){
									obj_pdf_i.push({text:item, alignment:j>1?'right':'left'});
								}else{
									var index = pdf_i.findIndex(obj => obj[0].text === item);

									if(index === -1){
										obj_pdf_i.push({text:item, colSpan:list.length-1, bold:1,fillColor:'#dfdfdf'});
										pdf_i.push(obj_pdf_i);
										obj_pdf_i = [];
									}

								}
							})

							pdf_i.push(obj_pdf_i)
						});

						var obj_j = [];
						var obj_pdf_j = [];
						response.sectionJ.table.map((t)=>{
							columns_j.map((c)=>{
								obj_j.push(t[c.key]);
								obj_pdf_j.push({text:t[c.key], alignment:'center'});
							});
						});
						list_j.push(obj_j);
						pdf_j.push(obj_pdf_j);
						
						this.setState({
							columns_d:columns_d,
							columns_e:columns_e,
							listado_a1:list_a1,
							listado_a2:list_a2,
							columns_a3:columns_a3,
							listado_a3:list_a3,
							columns_a4:columns_a4,
							listado_a4:list_a4,
							columns_a5:columns_a5,
							listado_a5:list_a5,
							columns_a6:columns_a6,
							listado_a6:list_a6,
							listado_c:list_c,
							listado_d:list_d,
							listado_g1:list_g1,
							listado_g2:list_g2,
							listado_e:list_e,
							listado_h:list_h,
							listado_j:list_j,
							columns_i:columns_i,
							listado_i:list_i,
							tbl_a:pdf_a,
							tbl_d:pdf_d,
							tbl_h:pdf_h,
							tbl_g:pdf_g,
							tbl_i:pdf_i,
							tbl_j:pdf_j,
						})

						var targets = [];
						this.state.columns_a1.map((c, i)=>{ if(i>0){ targets.push(i); } });
						defs_a1.push({targets:targets, className: 'dt-right'});

						targets = [];
						this.state.columns_a2.map((c, i)=>{ targets.push(i) });
						defs_a2.push({targets:targets, className: 'dt-right'});

						targets = [];
						columns_a3.map((c, i)=>{ if(i>0){ targets.push(i); } });
						defs_a3.push({targets:targets, className: 'dt-right'});

						targets = [];
						columns_a4.map((c, i)=>{ if(i>0){ targets.push(i); } });
						defs_a4.push({targets:targets, className: 'dt-right'});

						targets = [];
						columns_a5.map((c, i)=>{ if(i>0){ targets.push(i); } });
						defs_a5.push({targets:targets, className: 'dt-right'});

						targets = [];
						columns_a6.map((c, i)=>{ if(i>0){ targets.push(i); } });
						defs_a6.push({targets:targets, className: 'dt-right'});

						targets = [];
						this.state.columns_c.map((c, i)=>{ if(i>0){ targets.push(i); } });
						defs_c.push({targets:targets, className: 'dt-right'});

						targets = [];
						defs_d.push({targets:[0], visible:false});
						columns_d.map((c, i)=>{ if(i>1){ targets.push(i); } });
						defs_d.push({targets:targets, className: 'dt-right'});

						targets = [];
						columns_e.map((c, i)=>{ if(i>0){ targets.push(i); } });
						defs_e.push({targets:targets, className: 'dt-right'});

						defs_g1.push({targets:[2], className: 'dt-right'});
						defs_g2.push({targets:[2], className: 'dt-right'});

						targets = [];
						this.state.columns_h.map((c, i)=>{ if(i>0){ targets.push(i); } });
						defs_h.push({targets:targets, className: 'dt-right'});

						targets = [];
						defs_i.push({targets:[0], visible:false});
						columns_i.map((c, i)=>{ if(i>1){ targets.push(i); } });
						defs_i.push({targets:targets, className: 'dt-right'});

						targets = [];
						this.state.columns_j.map((c, i)=>{ targets.push(i) });
						defs_j.push({targets:targets, className: 'dt-right'});



						setTimeout(()=>{
							
							this.resetTable(this.el_a1, 'a1', this.state.columns_a1, this.state.listado_a1,'25em','', defs_a1);
							this.resetTable(this.el_a2, 'a', this.state.columns_a2, this.state.listado_a2, '5em','', defs_a2);
							this.resetTable(this.el_a3, 'a', this.state.columns_a3, this.state.listado_a3, '5em','', defs_a3);
							this.resetTable(this.el_a4, 'a', this.state.columns_a4, this.state.listado_a4, '28em','', defs_a4);
							this.resetTable(this.el_a5, 'a', this.state.columns_a5, this.state.listado_a5, '25em','', defs_a5);
							this.resetTable(this.el_a6, 'a', this.state.columns_a6, this.state.listado_a6, '5em','', defs_a6);	
							this.resetTable(this.el_c, 'c', this.state.columns_c, this.state.listado_c, '20em','', defs_c);
							this.resetTable(this.el_d, 'd', this.state.columns_d, this.state.listado_d,'32em','headers', defs_d);
							this.resetTable(this.el_e, 'e', this.state.columns_e, this.state.listado_e,'30em','', defs_e);
							this.resetTable(this.el_g1, 'g1', this.state.columns_g1, this.state.listado_g1, '25em','', defs_g1);
							this.resetTable(this.el_g2, 'g', this.state.columns_g2, this.state.listado_g2, '25em','', defs_g2);
							this.resetTable(this.el_i, 'i', this.state.columns_i, this.state.listado_i,'32em','headers', defs_i);
							this.resetTable(this.el_h, 'h',	this.state.columns_h, this.state.listado_h, '32em','', defs_h);
							this.resetTable(this.el_j, 'j',	this.state.columns_j, this.state.listado_j, '5em','', defs_j);
						}, 500)
					}

				});
			}else{
				swal('Error', 'La Fecha Hasta debe ser mayor o igual a Fecha Desde', 'error');
			}
		}else{
			swal('Error', 'Campos Incompletos', 'error');
		}
	}

	dateCompare(){
		var ini = moment(this.state.start_date);
		var fin = moment(this.state.end_date);
		var date_ok = true;

		if(ini !== 'Invalid date' && fin !== 'Invalid date'){
			if(fin < ini){
				date_ok = false;
				document.getElementById('end_date').classList.add('error');
			}else{
				document.getElementById('end_date').classList.remove('error');
			}
		}else{
			date_ok = false;
		}		

		return date_ok;
	}

	isValidForm() {
		const select = document.querySelector('form');
		const inputs = select.querySelectorAll('input, select');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
	    		
		      	const isInputValid = this.showCtrlError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		    	
		   
		  	}
	    });	    

	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {

			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		

		return res;
	}

	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page">
					{session} ->
					{t('sidebar.nav.reports.MAIN')} ->
					Donantes ->
					{this.state.filename}
					</h5>
				</div>
				<Help 
					{...this.props}
		            menu={"help_donors"} 
		            submenu={"help_cnts"}  />
				<div className="form-group" style={{paddingLeft:"0.5em"}}>
					<div className="col-xs-12">
						<form noValidate>
							<div className="col-xs-12"><span>Campos Requeridos (*)</span></div>
							<div className="col-xs-12 col-sm-2" style={{borderRight:"1px solid #e0e0e0"}}>
								
								<div className="col-xs-12 form-group" >
									<span className="span-min">Fecha Desde</span><span> (*)</span>
									<input type="date" className="form-control hour-input" name="start_date" id="start_date"
										value={this.state.start_date} onChange={this.handleChange} required />
								</div>
								<div className="col-xs-12 form-group" >
									<span className="span-min">Fecha Hasta</span><span> (*)</span>
									<input type="date" className="form-control hour-input" name="end_date" id="end_date"
										value={this.state.end_date} onChange={this.handleChange} required />
								</div>

								{/*<div style={{textAlign:"right"}} className="form-group"> 
									<button type="button" className="btn btn-info" onClick={this.searching} style={{fontSize:"1em"}}>
										Buscar
									</button>
								</div>*/}

								<div style={{textAlign:"right"}}>
									<button type="button" className="btn btn-info" onClick={this.excel_report} style={{fontSize:"1em"}}>
										Descargar Informe Excel
									</button>
								</div>
							</div>

							<div className="col-xs-12 col-sm-10">
								<div className="col-xs-12" style={{marginTop:"20px",textAlign: "center",fontWeight: "bold",textDecoration: "underline", fontSize:'16px'}}>
									<span>
										{this.state.filename}
									</span>
								</div>
								<div className="col-xs-12" style={{textAlign:'center'}}>
									<span>
										Información Del:  {this.state.start_date !== "" ?
											moment(this.state.start_date).format("DD/MM/YYYY")
										: ''}    
									</span>
									<span style={{marginLeft:"5px"}}>	
										Al: {this.state.end_date !== "" ?
											moment(this.state.end_date).format("DD/MM/YYYY")
										: ''}
									</span>
								</div>

								{/*<h3 className="color-font">Sección A - Uso alogénico.</h3>
								<div className="col-xs-12 form-group" id="table-a">
									<h4 style={{margin:'0'}} >Donantes alogénicos</h4>
									<div className="table-responsive">
										<table style={{fontSize:"11px"}} className="expenses-discards" id="sec_a1" width="100%" ref={el => this.el_a1 = el}>
										</table>
									</div>
									<h4>Donantes de acuerdo a edad y sexo</h4>
									<div className="table-responsive">
										<table style={{fontSize:"11px"}} className="expenses-discards" id="sec_a2" width="100%" ref={el => this.el_a2 = el}>
										</table>
									</div>
									<h4>Existencias al inicio del mes que informa</h4>
									<div className="table-responsive">
										<table style={{fontSize:"11px"}} className="expenses-discards" id="sec_a3" width="100%" ref={el => this.el_a3 = el}>
										</table>
									</div>
									<h4>Ingresos y Altas</h4>
									<div className="table-responsive">
										<table style={{fontSize:"11px"}} className="expenses-discards" id="sec_a4" width="100%" ref={el => this.el_a4 = el}>
										</table>
									</div>
									<h4>Egresos y Bajas</h4>
									<div className="table-responsive">
										<table style={{fontSize:"11px"}} className="expenses-discards" id="sec_a5" width="100%" ref={el => this.el_a5 = el}>
										</table>
									</div>
									<h4>Existencias al término del mes que informa</h4>
									<div className="table-responsive">
										<table style={{fontSize:"11px"}} className="expenses-discards" id="sec_a6" width="100%" ref={el => this.el_a6 = el}>
										</table>
									</div>
								</div>
								<h3 className="color-font">Sección C - Eventos o reacciones adversas a la donación.</h3>
								<div className="col-xs-12 form-group" id="table-c">
									<h4 style={{margin:'0'}}>Eventos adversos a la donación</h4>
									<div className="table-responsive">
										<table style={{fontSize:"11px"}} className="expenses-discards" id="sec_c" width="100%" ref={el => this.el_c = el}>
										</table>
									</div>
								</div>

								<h3 className="color-font">Sección D - Resultados de las pruebas de detección de agentes transmisibles por transfusión.</h3>
								<div className="col-xs-12 form-group" id="table-d">
									<h4 style={{margin:'0'}}></h4>
									<div className="table-responsive">
										<table style={{fontSize:"11px"}} className="expenses-discards" id="sec_d" width="100%" ref={el => this.el_d = el}>
										</table>
									</div>
								</div>
								<h3 className="color-font">Sección E - Resultados de otras pruebas de detección de agentes transmisibles por transfusión en donantes alogénicos.</h3>
								<div className="col-xs-12 form-group" id="table-e">
									<div className="table-responsive">
										<table style={{fontSize:"11px"}} className="expenses-discards" id="sec_e" width="100%" ref={el => this.el_e = el}>
										</table>
									</div>
								</div>
								<h3 className="color-font">Sección G - Colectas de sangre en puestos de sangrado fijos y colectas externas efectuadas por el banco de sangre.</h3>
								<div className="col-xs-12 form-group" id="table-g">
									<h4 style={{margin:'0'}}>Colectas de sangre en puestos de sangrado fijo</h4>
									<div className="table-responsive">
										<table style={{fontSize:"11px"}} className="expenses-discards" id="sec_g1" width="100%" ref={el => this.el_g1 = el}>
										</table>
									</div>
									<br/>
									<h4 style={{margin:'0'}}>Colectas Externas</h4>
									<div className="table-responsive">
										<table style={{fontSize:"11px"}} className="expenses-discards" id="sec_g2" width="100%" ref={el => this.el_g2 = el}>
										</table>
									</div>
								</div>

								<h3 className="color-font">Sección H - Causas de diferimiento o rechazo de donantes por género y rango de edad.</h3>
								<div className="col-xs-12 form-group" id="table-h">
									<div className="table-responsive">
										<table style={{fontSize:"11px"}} className="expenses-discards" id="sec_h" width="100%" ref={el => this.el_h = el}>
										</table>
									</div>
								</div>
								<h3 className="color-font">Sección I - Desglose de intercambio de unidades de sangre y componentes sanguíneos.</h3>
								<div className="col-xs-12 form-group" id="table-i">
									<div className="table-responsive">
										<table style={{fontSize:"11px"}} className="expenses-discards" id="sec_i" width="100%" ref={el => this.el_i = el}>
										</table>
									</div>
								</div>
								<h3 className="color-font">Sección J - Grupo sanguíneo de los donadores.</h3>
								<div className="col-xs-12 form-group" id="table-j">
									<h4 style={{margin:'0'}}>Grupo sanguíneo y Rh</h4>
									<div className="table-responsive">
										<table style={{fontSize:"11px"}} className="expenses-discards" id="sec_j" width="100%" ref={el => this.el_j = el}>
										</table>
									</div>
								</div>
								*/}{/*<div className="col-xs-12">
									<span>Total: </span><label style={{marginLeft:'5px'}}>{this.state.total}</label>
									<span style={{marginLeft:'8px'}}>Compatibles: </span><label style={{marginLeft:'5px'}}>{this.state.compatible}</label>
									<span style={{marginLeft:'8px'}}>Incompatibles: </span><label style={{marginLeft:'5px'}}>{this.state.incompatible}</label>
								</div>*/}
							</div>
						</form>
					</div>
				</div>
			</div>
		)
	}
}

export default translate('translations') (CNTSReport);